const InfoButton = ({func}) => {
    const OnClick = (event) => {
        event.preventDefault();
        func();
    }
    
    return <button
        className="rounded-full bg-blue-500 text-white w-10 h-10 flex items-center justify-center"
        onClick={e => OnClick(e)}
    >i</button>
}

export default InfoButton;